import { _137C, Fury, Green } from './palette';

export const infoBlockBorderColorError = Fury;
export const infoBlockBorderColorSuccess = Green;
export const infoBlockBorderColorWarning = _137C;
